import { BaseModal } from './base-modal'
import styles from './styles/modal-right.module.scss'
import { ModalWindowProps } from './types/modal.types'

export const ModalRight = (props: ModalWindowProps) => {
  return (
    <BaseModal
      className={styles.modalWindowRight}
      {...props}
    >
      {props.children}
    </BaseModal>
  )
}
